import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class DatosService {

  constructor(){}

  SocialMedia = [

    { link : 'https://www.facebook.com/peluqueriajuliomatamoros/' , title : 'facebook' , icon : 'fa fa-facebook-square'},
    { link : 'https://www.instagram.com/juliomatamoros_hair/' , title : 'instagram' , icon : 'fa fa-instagram'}
  
  ]

  servicesTile = [
    { photo : '/assets/img/balayage.jpg', title : 'Balayage' , description : 'Es una técnica francesa, con la que se consigue una distribución uniforme de luz y brillo con el color.' , price : 'Desde 150€'},
    { photo : '/assets/img/tinte.jpg', title : 'Tinte' , description : 'Un gran cambio lleno de magia y elaborado con los mejores productos que hacen que tu pelo esté sano y espectacular.' , price : 'Desde 25€'},
    { photo : '/assets/img/corte.jpg', title : 'Corte' , description : 'Cortes modernos y de tu preferencia, te hacemos lo que tú necesites para verte más hermosa.' , price : 'Desde 28€'},
    { photo : '/assets/img/peinado.jpg', title : 'Peinado' , description : 'Los peinados más espectaculares, para novias, fiestas, eventos especiales, para la ocasión que desees.' , price : 'Desde 12€'},
    { photo : '/assets/img/extensiones.jpg', title : 'Extensiones' , description : 'Te ofrecemos extensiones para todo tipo de cabello, para que tu melena luzca hermosa y espectacular.' , price : 'Desde 80€'},
    { photo : '/assets/img/hidratacion.jpg', title : 'Hidratación' , description : 'El increíble poder orgánico de la enzymoterapia capaz de recuperar y dejar un cabello muy hidratado.' , price : 'Desde 45€'},
    { photo : '/assets/img/alisado.jpg', title : 'Alisado' , description : 'Técnica que consiste en eliminar totalmente el ondulado natural que ofrece un cabello rizado para transformarlo en liso.' , price : 'Desde 145€'},
    { photo : '/assets/img/maquillaje.jpg', title : 'Maquillaje' , description : 'El maquillaje para tu día perfecto, lucirás radiante con nuestros mejores estilistas y maquilladores profesionales.' , price : 'Desde 50€'}
  ]

  quotes = [
    { clase : 'slide1' , text : 'Me ha encantado pasar por tus maravillosas manos y las de todo tu equipo. Me he sentido como una princesa!! Volveremos sin duda!! Muy feliz con el resultado y mi chico más.❤️🔝👏🏼👏🏼👏🏼' , author : '@mariana_green_slow'},
    { clase : 'slide2' , text : 'Apoteósico el trabajo ! La entrega y el amor , ese no tiene precio ! Los quiero grandote ! Sois los mejores.😍😎' , author : '@fcheskahdez'},
    { clase : 'slide3' , text : 'Yeah! 👏🏻👏🏻👏🏻❤️ Buen trabajo chicos!!! Es así una “Miss” una Reina de belleza sin asesoría tiene que prender muchas velas 🕯 para pedir milagros! Pero con una buena asesoría de seguro tendrá mejores resultados por conocer bien la disciplina. Felicitaciones por el trabajo y los resultados. Abrazo y que este año 2020 sea de grandes éxitos. 👑🔝❤️🇻🇪❤️ 🇪🇸 ❤️Soy de los que aplaude las cosas buenas de pie.' , author : '@alexanderimage'},
    { clase : 'slide4' , text : 'Es que tienes una manos...( conocimiento, preparación, disciplina, entrega, sencillez, voluntad, amor y pasión por lo que haces). Me encanta!' , author : '@pilarecontreras'} 
  ]

  public services = {
    BALAGAYE: [
      {service:"Melena media", price:"Desde 150€" , id: "b1", type: 'Balayage'},
      {service:"Melena larga", price:"Desde 200€" , id: "b2", type: 'Balayage' },
      {service:"Retoque", price:"Desde 90€", id: "b3", type: 'Balayage'},
      {service:"Mechas", price:"Desde 120€", id: "b4", type: 'Balayage'},
      {service:"Mechas frontales", price:"Desde 60€", id: "b5", type: 'Balayage'}
    ],

    TINTE: [
      {service:"Solo raíz", price:"Desde 25€", id: "t1", type: 'Tinte'},
      {service:"Global", price:"Desde 30€", id: "t2", type: 'Tinte'},
      {service:"Reflejos", price:"Desde 90€", id: "t3", type: 'Tinte'}
    ],
      
    CORTE: [
      {service:"Solo Puntas", price:"Desde 28€", id: "c1", type: 'Corte' },
      {service:"Completo", price:"Desde 35€", id: "c2", type: 'Corte'},
      {service:"Subida de Extensiones", price:"Desde 80€", id: "c3", type: 'Corte'}
    ],

    PEINADO: [
      {service:"Corto", price:"Desde 12€", id: "p1", type: 'Peinado'},
      {service:"Medio", price:"Desde 15€", id: "p2", type: 'Peinado'},
      {service:"Largo", price:"Desde 18€", id: "p3", type: 'Peinado'},
      {service:"Recogido", price:"Desde 50€", id: "p4", type: 'Peinado'}
    ],

    RITUALES: [
      {service:"Hidratación", price:"Desde 45€", id: "r1", type: 'Rituales'},
      {service:"Melena Larga", price:"Desde 60€", id: "r2", type: 'Rituales'}
    ],

    ALISADO: [
      {service:"Alisado Extremo de Enzimoterapia", price:"Desde 145€", id: "a1", type: 'Alisado'}
    ],

    MAQUILLAJE: [
      {service:"Maquillaje", price:"Desde 50€", id: "m1", type: 'Maquillaje'},
      {service:"Maquillaje Novia", price:"Desde 100€", id: "m2", type: 'Maquillaje'},
      {service:"Maquillaje Novia fuera", price:"Desde 150€", id: "m3", type: 'Maquillaje'},
      {service:"Invitada fuera", price:"Desde 100€", id: "m4", type: 'Maquillaje'},
      {service:"Peinado fuera", price:"Desde 100€", id: "m5", type: 'Maquillaje'},
    ],

  }
}
